<template>
  <section class="TcLogin h-full">
    <div class="container mx-auto h-full">
      <div class="flex flex-col gap-6 justify-center content-center mx-auto max-w-2xl h-full">
        <input type="text"     class="input-login" name="uno" placeholder="Usuario" autocomplete="off" v-model="username" />
        <input type="password" class="input-login" name="dos" placeholder="Contraseña" autocomplete="off" v-model="password" />
        <button class="mt-8" @click="login">Continuar</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TcLogin",
  data() {
    return {
      username: '',
      password: '',
      access_token: null,
    };
  },
  methods: {
    login: function () {
      //console.log('FETCH LOGIN');
      //console.log(this, this.username, this.password);
      return fetch('/auth.php', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: this.username,
          password: this.password,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.access_token) {
            this.access_token = data.access_token;
            this.$root.setAccessToken(this.access_token);
            //console.log('parent', this.$parent);
            this.$root.setPage('home');
            this.$root.loadUserData();
          }
          //console.log("LOGIN DATA", data);
        })
        .catch((err) => {
          //console.error("HAY UN ERROR", err);
        });
    },
  },
  mounted() {
    const isDebug = this.$root.debug === true || this.$root.debug === 'true' || this.$root.debug === '1';
    const defaultUsername = this.$root.$el.dataset.username;
    if (isDebug && defaultUsername) {
      this.username = defaultUsername;
      this.password = this.$root.$el.dataset.password || '';
    }
  },
  created() {
    //console.log('CREATED LOGIN', this);
  }
};
</script>